import React, { useEffect } from "react";

import { DashboardConnectProvider } from "../../components/Dashboard/shared/DashboardConnectProvider";
import { MainDashboard } from "../../components/Dashboard/MainDashboard";
import { Analytics } from "../../services/analytics/Analytics";
import { DashboardFooter } from "./layout/DashboardFooter";
import { DashboardHeader } from "./layout/DashboardHeader";

export const DashboardScreen = () => {
  useEffect(() => {
    Analytics.capture("dashboard_viewed");
  }, []);

  return (
    <div className="bg-zeos-white-md flex flex-col min-h-screen">
      <DashboardHeader />
      <div className="bg-zeos-white-md flex-grow">
        <DashboardConnectProvider>
          <MainDashboard />
        </DashboardConnectProvider>
      </div>
      <DashboardFooter />
    </div>
  );
};
